import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { HubLocationService } from '../services/HubLocationService'
export const getAllHubLocations = createAsyncThunk(
  'hubLocation/getAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await HubLocationService.getAll()
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const getOneHubLocation = createAsyncThunk(
  'hubLocation/getOne',
  async (data, { rejectWithValue }) => {
    try {
      const response = await HubLocationService.getOne(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const createHubLocation = createAsyncThunk(
  'hubLocation/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await HubLocationService.createHubLocation(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const editHubLocation = createAsyncThunk(
  'hubLocation/edit',
  async (data, { rejectWithValue }) => {
    try {
      const response = await HubLocationService.editHubLocation(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const deleteHubLocation = createAsyncThunk(
  'hubLocation/delete',
  async (data, { rejectWithValue }) => {
    try {
      const response = await HubLocationService.deleteOne(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

const initialState = {
  data: [],
  singleData: {},
  loading: false,
  error: false,
  message: '',
}

const slice = createSlice({
  name: 'hubLocation',
  initialState,
  reducers: {
    checkAll: (state) => {
      state.isChecked = !state.isChecked
    },
    resetSingleData: (state) => {
      state.singleData = {}
    },
  },
  extraReducers: {
    [getAllHubLocations.pending]: (state) => {
      if (state.data.length <= 0) {
        state.loading = true
      }
    },
    [getAllHubLocations.fulfilled]: (state, action) => {
      state.error = false
      state.data = action.payload
      state.loading = false
    },
    [getAllHubLocations.rejected]: (state, action) => {
      state.error = true
      state.message = action.payload
      state.loading = false
    },

    [getOneHubLocation.pending]: (state) => {
      state.loading = true
    },
    [getOneHubLocation.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [getOneHubLocation.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [createHubLocation.pending]: (state) => {
      state.loading = true
    },
    [createHubLocation.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [createHubLocation.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [editHubLocation.pending]: (state) => {
      state.loading = true
    },
    [editHubLocation.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [editHubLocation.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [deleteHubLocation.pending]: (state) => {
      state.loading = true
    },
    [deleteHubLocation.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [deleteHubLocation.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },
  },
})

export const { resetSingleData } = slice.actions
export default slice.reducer
